import type { RequestContext, Client } from "../client";
import type { IProfiler } from "../resources/IProfiler";
export class MiniProfilerRepository {
    constructor(private readonly client: Client, private readonly requestContext: RequestContext) { }
    getProfiler(profilerId: string): Promise<IProfiler> {
        return this.client.get(this.requestContext, `/mini-profiler/results?id=${profilerId}`);
    }
}
